"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
class NotificationNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.NOTIFICATION };
    if (props.type !== types_1.NODE_TYPES.NOTIFICATION)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      type: types_1.NotificationType.EMAIL,
      message: "",
      slackConfig: "",
      notifyEmail: "",
      notifyOnlyOnData: true
    };
    if (!nodeData) return deserializeData;
    deserializeData = {
      message: nodeData.message,
      type: nodeData.transport.type,
      slackConfig: nodeData.transport.options.slackConfig || "",
      notifyEmail: nodeData.transport.options.notifyEmail || "",
      notifyOnlyOnData: nodeData.notifyConditions.onlyOnData
    };
    return deserializeData;
  }
  serialize(uiData) {
    let nodeData = {
      transport: {
        type: uiData.type,
        options: {
          slackConfig: uiData.slackConfig || "",
          notifyEmail: uiData.notifyEmail || ""
        }
      },
      message: uiData.message,
      notifyConditions: { onlyOnData: uiData.notifyOnlyOnData }
    };
    return nodeData;
  }
  validate() {
    return new validations_1.NotificationNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.NotificationNode = NotificationNode;
//# sourceMappingURL=NotificationNode.js.map
